import { render, staticRenderFns } from "./CreateTag.vue?vue&type=template&id=2aea2793&"
import script from "./CreateTag.vue?vue&type=script&lang=js&"
export * from "./CreateTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aea2793')) {
      api.createRecord('2aea2793', component.options)
    } else {
      api.reload('2aea2793', component.options)
    }
    module.hot.accept("./CreateTag.vue?vue&type=template&id=2aea2793&", function () {
      api.rerender('2aea2793', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Story/Modals/CreateTag.vue"
export default component.exports